import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCategoriesComponent } from './product-categories.component';
import { UploadPdfBillComponentModule } from '../add-bill/upload-pdf-bill/upload-pdf-bill.module';
import { IonicModule } from '@ionic/angular';
import { SortByPipe } from '@1bill-app/pipes/sort-by.pipe';



@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    CommonModule,
    UploadPdfBillComponentModule,
    // SortByPipe,
  ],
  declarations: [
   ProductCategoriesComponent
  ],
  entryComponents: [],
  exports: [ProductCategoriesComponent],
})
export class ProductCategoriesComponentModule { }